/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import * as React from 'react'; // @ts-ignore

import extend from 'just-extend';
import en_US from './en_US';
export var LocaleContext = /*#__PURE__*/React.createContext(en_US);
var LocaleProvider = function LocaleProvider(props) {
  var _React$useContext;
  var locale = props.locale,
    children = props.children;
  var parentLocale = (_React$useContext = React.useContext(LocaleContext)) !== null && _React$useContext !== void 0 ? _React$useContext : {};
  return (/*#__PURE__*/
    // this is poorly documented but specifying true enforces that the object is deeply extended
    // https://www.npmjs.com/package/just-extend
    React.createElement(LocaleContext.Provider, {
      value: extend(true, {}, en_US, parentLocale, locale)
    }, children)
  );
};
export default LocaleProvider;